export default __webpack_public_path__ + "static/media/icon-info-gray-solid.8cf91313.svg";